module.exports = __webpack_public_path__ + "img/guali1.f8d22893.jpg";